import * as React from 'react';

import {PageTitleBar} from '../../layout/page-title-bar';
import {FeatureGatePageWrapper} from '../../limits/feature-gates/feature-gate-page-wrapper';

type Props = {
    reportKey: string;
};

export function ReportFeatureGatePageWrapper(props: Props) {
    switch (props.reportKey) {
        case 'losses':
            return (
                <FeatureGatePageWrapper
                    header='Learn why you’re losing leads'
                    subHeader='Get the insights you need to reduce lost deals and improve strategies.'
                    bullets={[
                        'Segment data by outcome, competitor, or product to uncover patterns in losses.',
                        'Compare by deal value or quantity to understand the full impact of missed opportunities.',
                        'Track trends over time to adjust and improve based on what really matters to your bottom line.',
                    ]}
                    feature='lossesReport'
                />
            );
        case 'forecast':
            return (
                <FeatureGatePageWrapper
                    header='Plan with confidence for your sales goals'
                    subHeader='Gain clarity on your sales performance and plan effectively for the future.'
                    bullets={[
                        'Easily analyze your current leads and sales performance at a glance.',
                        'Adjust your forecasts based on lead confidence to focus on the most promising opportunities.',
                        'Easily share and save reports for quick updates and team discussions.',
                    ]}
                    feature='forecastReport'
                />
            );
        case 'snapshots':
            return (
                <>
                    <PageTitleBar
                        title='Snapshots'
                        subheaderPrimaryText='How have we changed over time?'
                    />
                    <FeatureGatePageWrapper
                        header='Plan with confidence for your sales goals'
                        subHeader='Gain clarity on your sales performance and plan effectively for the future.'
                        bullets={[
                            'Easily analyze your current leads and sales performance at a glance.',
                            'Adjust your forecasts based on lead confidence to focus on the most promising opportunities.',
                            'Easily share and save reports for quick updates and team discussions.',
                        ]}
                        feature='forecastReport'
                    />
                </>
            );
        default:
            return (
                <FeatureGatePageWrapper
                    header='Get insights tailored to your leads'
                    subHeader='Tailor reports to reveal trends that matter most, from win rates to team performance.'
                    bullets={[
                        'Focus on specific data by filtering by territory, product, source, or other criteria.',
                        'Segment by outcome or stage to compare lead volumes and values across your team.',
                        'Save, export, and share reports to keep everyone on the same page.',
                    ]}
                    feature='customReport'
                />
            );
    }
}
